// @ts-nocheck
// Import AOS
import AOS from 'aos'
import 'aos/dist/aos.css'

// Import Bouncer
import * as Bouncer from 'formbouncerjs'

// Import components
import SplitText from './splitText'
import Loader from '../components/loader'

declare global {
    interface Window {
        dataLayer: any
    }
}

export const page = async () => {
    window.onload = function () {
        initialize()
        new Loader()
    }
}

function initialize() {
    setupSplits()
    setCity()
    validateForm()
    openModal()
    closeModal()
    createUlElement()
    //AOS
    AOS.init({
        once: true,
    })
}

function closeModal() {
    const modalOk = document.querySelector('.modalOk[data-modal="registro-ok"]')
    const close = modalOk.querySelector('.modalOk-close')

    if (close) {
        close.addEventListener('click', () => {
            modalOk.classList.add('is-close')
        })
    }
}

function openModal() {
    const status = new URL(location).searchParams.get('status')
    if (status) {
        const modalOk = document.querySelector('.modalOk[data-modal="registro-ok"]')
        const cityRegistro = localStorage.getItem('formCity')
        const btnQuito = modalOk.querySelector('#btn-quito')
        const btnOtro = modalOk.querySelector('#btn-otro')

        if (modalOk) {
            modalOk.classList.remove('is-close')
            if (cityRegistro == '2') {
                btnOtro.classList.add('hidde')
                btnQuito.classList.remove('hidde')
            }

            else {
                btnQuito.classList.add('hidde')
                btnOtro.classList.remove('hidde')
            }
        }
    }
}

function setupSplits() {
    new SplitText('.content__title')
    new SplitText('.content__parag p')
}

function setCity() {
    const inputCity = document.getElementById('edit-city_tid')
    const cityRegistro = localStorage.getItem('formCity')

    if (cityRegistro) {
        inputCity.value = cityRegistro
    }

    else {
        window.location.pathname = 'meals'
    }
}

function validateForm() {
    var validate = new Bouncer('#grill-register-form', {
        messages: {
            missingValue: {
                default: 'Campo Obligatorio'
            },
        },
    });
}

function createUlElement() {
    const itemName = document.querySelector('.form-item-name')
    const ulElem = document.createElement('ul')
    ulElem.classList.add('autocomplete-ul')
    ulElem.style.zIndex = 2
    itemName.appendChild(ulElem)

    autocompleteNameParrilla()
}

function autocompleteNameParrilla() {
    const itemName = document.querySelector('.form-item-name')
    const inputElem = itemName.querySelector('#edit-name')
    const ulElem = itemName.querySelector('ul.autocomplete-ul') as HTMLElement
    ulElem.innerHTML = ''
    inputElem.addEventListener('input', (event) => {
        let valueInput = event.target.value

        if (valueInput == '' || valueInput.length < 3) return ulElem.innerHTML = ''        

        valueAutocomplete(valueInput)
            .then((values) => {
                ulElem.innerHTML = ''
                if (inputElem.value === '') return


                for (const item of values) {
                    let liAutocomplete = document.createElement('li');
                    liAutocomplete.classList.add('autocomplete-option');
                    liAutocomplete.textContent = item.name;
                    ulElem.appendChild(liAutocomplete);
                }
            })
            .catch((err) => {
                console.log(err)
            })
    })

    inputElem.addEventListener('blur', () => {
        setTimeout(() => {
            ulElem.innerHTML = ''
        }, 200);
    })

    ulElem.addEventListener('click', (e) => {
        handleResultClick(e)
    })
}

async function valueAutocomplete(text: string) {
    const request = await fetch(`/grill/data/${text}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })

    const response = await request.json()

    if (Array.isArray(response.data)) {
        return [...response.data]
    }

    return []
}

function handleResultClick(event) {
    if (event.target && event.target.nodeName === "LI") {
        selectItem(event.target)
    }
}

function selectItem(node) {
    const inputElem = document.querySelector('#edit-name')
    if (node) {
        inputElem.value = node.innerText
        hideResults();
    }
}

function hideResults() {
    const ulElem = document.querySelector('ul.autocomplete-ul')
    ulElem.innerHTML = ''
}